import { M8PartnerInfo } from 'services/production/types';
import { PartnerProfileFormValues } from 'types/partnerProfileFormTypes';
import { UnexpectedError } from 'utils/errors';

export const normalizePartnerProfileFormValues = (
  partnerProfileFormValues: PartnerProfileFormValues
) => ({
  toM8PartnerInfo(): M8PartnerInfo {
    if (partnerProfileFormValues.country === null) {
      throw new UnexpectedError();
    }

    return {
      firstName: partnerProfileFormValues.firstName,
      lastName: partnerProfileFormValues.lastName,
      middleName: partnerProfileFormValues.middleName,
      phone: partnerProfileFormValues.phone,
      country: partnerProfileFormValues.country,
      city: partnerProfileFormValues.city,
      aboutMyself: partnerProfileFormValues.details,
    };
  },
});
